import axios from 'axios'
import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { secondaryFormatter } from './utils'
import UploadSection from './UploadSection'
import LastUploadedSection from '../components/LastUploadedSection'
import RegularColumnSelection from '../components/RegularColumnSelection'

import { hasAllRequiredColumnValues } from './SourceDataMethods'
import { API_URL } from '../../../config'
import { firstLetterUpper } from '../../../util/stringTransform'
import toast from 'react-hot-toast'
import { logError } from '../../../util/logger'

const useStyles = makeStyles(() => ({
  breakLine: {
    margin: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  root: {},
}))

const MoLineageSourceData = ({ uploadSummary, refetchData, setExpand }) => {
  const classes = useStyles()

  const currentColumnRef = uploadSummary?.columnRef
  const currentSheetSelected = uploadSummary?.sheetNameToSelect
  const currentUploadedFile = uploadSummary?.fileName
  const lastImported = uploadSummary?.lastImported
  const fileStructure = uploadSummary?.fileStructure
  const fileToken = uploadSummary?.fileToken
  const status = uploadSummary?.status
  const statusMessage = uploadSummary?.statusMessage

  const [sheet, setSheet] = useState(currentSheetSelected || '')
  const [currentColumnList, setCurrentColumnList] = useState(currentSheetSelected ? secondaryFormatter(fileStructure, currentSheetSelected) : [])

  const [rootMoId, setRootMoId] = useState(currentColumnRef?.rootMoId || '')
  const [moId, setMoId] = useState(currentColumnRef?.moId || '')
  const [level, setLevel] = useState(currentColumnRef?.level || '')
  const [partNumber, setPartNumber] = useState(currentColumnRef?.level || '')

  const [disableSave, setDisableSave] = useState(true)

  const setColumnData = (inputSheet, sheetName) => {
    setCurrentColumnList(secondaryFormatter(inputSheet.fileStructure, sheetName))
  }

  const changeSheet = (sheetName) => {
    if (sheetName === '') {
      setCurrentColumnList([])
    } else setColumnData(uploadSummary, sheetName)
    setSheet(sheetName)
  }

  const criticalColumnConfig = [
    {
      label: 'Root MO ID',
      ref: rootMoId,
      refSet: setRootMoId,
      required: true,
    },
    {
      label: 'MO ID',
      ref: moId,
      refSet: setMoId,
      required: true,
    },
    {
      label: 'Level',
      ref: level,
      refSet: setLevel,
      required: true,
    },
    {
      label: 'Part Number',
      ref: partNumber,
      refSet: setPartNumber,
      required: true,
    },
  ]

  const allRequiredFieldsSelected = hasAllRequiredColumnValues(criticalColumnConfig)
  const handleFieldChange = (setStateFn, value) => {
    setStateFn(value)
    if (disableSave) setDisableSave(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const setMOLineageColumnRef = `${API_URL}/api/dataSource/v1/setMOLineageColumnRef`
    const data = {
      fileToken: fileToken,
      cleanImport: true,
      sheetName: sheet,
      columnRef: {
        rootMoId,
        moId,
        level,
        partNumber,
      },
    }

    const promise = axios
      .post(setMOLineageColumnRef, data)
      .then(async () => {
        await refetchData()
        setDisableSave(true)
        setExpand(false)
      })
      .catch((err) => {
        toast.error('Something went wrong while saving. Please try again')
        logError(err.message, err.stack)
      })

    toast.promise(promise, {
      loading: <div>{`Updating MO Lineage column mapping...`}</div>,
      success: <b>Updated!</b>,
      error: <b>We had an issue saving your changes, please try again!</b>,
    })
  }

  return (
    <Grid container spacing={2} direction='column' className={classes.root}>
      <UploadSection uploadDataType='moLineage' refetchSourceInfoFn={refetchData} setExpand={setExpand} uploadSummary={uploadSummary} />
      <hr className={classes.breakLine} />
      <LastUploadedSection
        fileName={currentUploadedFile}
        lastImported={lastImported}
        status={firstLetterUpper(status)}
        statusMessage={statusMessage}
        label={`MO Lineage`}
      />
      <hr className={classes.breakLine} />
      <RegularColumnSelection
        config={criticalColumnConfig}
        changeSheet={changeSheet}
        currentSheet={sheet}
        fileStructure={fileStructure}
        currentColumnList={currentColumnList}
        handleFieldChange={handleFieldChange}
        handleSubmit={handleSubmit}
        allRequiredFieldsSelected={allRequiredFieldsSelected}
        disableSave={disableSave}
      />
    </Grid>
  )
}

export default MoLineageSourceData
